/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:11
 * @LastEditTime: 2023-09-14 16:16:56
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\formCard\field.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Component } from "react";
import { Input, Tooltip } from "@platform/base";
import { match } from '../../libs/utils';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

/**
 * 左侧的属性面板
 */
class Field extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * 查询
     * @param {*} value 
     * @param {*} e 
     */
    onSearch = (value, e) => {
        const { store, code } = this.props;
        const fieldStore = store.getStore(['formCardData', code, 'field']) || {};
        const { data = [] } = fieldStore;

        const nextData = data.map(item => {
            const { $id, props = {} } = item;
            const { title } = props;
            // 是否是过滤的
            item.filtered = match(title, value);
            return item;
        });

        store.setStore(['formCardData', code, 'field', 'value'], value, false);
        store.setStore(['formCardData', code, 'field', 'data'], nextData, true);
        // TODO search
        // scrollIntoView 聚焦到首项
    }

    render() {

        const { store, code } = this.props;
        const langJson = store.getStore('langJson');
        const fieldStore = store.getStore(['formCardData', code, 'field']) || {};
        const { value, data = [] } = fieldStore;

        return <div
            className="field-wrapper"
            fieldid={getSysFieldid('left_area')}
        >
            <div className="field-search">
                <span className="field-search-label">{langJson['field-list-title'] || '待添加'}</span>
                <Input
                    className="field-search-input"
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                />
            </div>
            <ul className="field-list">
                {data.map((item, i) => {
                    const { $id } = item;
                    return <ListItem key={$id} areaCode={code} store={store} {...item} />;
                })}
            </ul>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 左侧点击选中
    onTransferToView = e => {
        const { store, areaCode, $id } = this.props;
        let nextViewSourceItem = null;
        {
            // 左边移除一个
            const fieldStore = store.getStore(['formCardData', areaCode, 'field']) || {};
            const { value, data = [] } = fieldStore;
            const nextData = data.filter(item => {
                const { props = {}, $id: current$id } = item;
                const { title } = props;
                if (current$id === $id) {
                    // 记录数据
                    nextViewSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(title, value);
                    return true;
                }
            });
            store.setStore(['formCardData', areaCode, 'field', 'data'], nextData, false);
        }
        {
            // 右边添加一个
            const viewStore = store.getStore(['formCardData', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;

            // 修改显隐性
            nextViewSourceItem.props.visible = true;

            // 显示
            let nextData = nextViewSourceItem ? [...data, nextViewSourceItem] : data;

            nextData = nextData.map(item => {
                const { $id, props = {} } = item;
                const { title } = props;
                // 是否是过滤的
                item.filtered = match(title, value);
                return item;
            });
            store.setStore(['formCardData', areaCode, 'view', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            filtered,
            props = {},
            $id,
            
        } = this.props;

        const {
            // TODO 多语
            title,
            visible,
            moduleId,
            // 唯一id
            com_id,
        } = props;

        const langJson = store.getStore('langJson');
        const multiLangItems = store.getStore('multiLangItems');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);
        const nextTitle = (multiLangItems[moduleId] || {}).tranitemvalue || title;

        return <li className="field-item">
            <div
                className={classnames({
                    'field-item-filtered': filtered,
                    'field-item-content': true,
                })}
            >
                {/* {required && <span className="unselected-mark iconfont icon-xinghao"></span>} */}
                <span className="field-label" title={nextTitle}>{nextTitle}</span>
                <span className="field-icon" onClick={this.onTransferToView}>
                    <Tooltip
                        placement="top"
                        overlay={langJson['action-icon-add']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('ncc-sq', 'close')} />
                    </Tooltip>
                </span>
            </div>
        </li>;
    }
}

export default Field;